module.exports = __webpack_public_path__ + "img/star-image-1.b0b62242.png";